module.exports = __webpack_public_path__ + "img/zwsj@2x.634e6e79.png";